/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);updateFreeShippingThersold();} else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
            $('.one_time').slick({
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                slidesToScroll: 1
            });
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);updateFreeShippingThersold();} else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                errorCallback(XMLHttpRequest, textStatus);
            },
                complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
  POST to cart/change.js as JSON.

  The form-encoded changeItem() above can only send line + quantity. This one
  sends a JSON body so quantity and selling_plan can move together in a single
  request, which is what keeps a subscription line's bundle size and delivery
  interval in step.

  Identify the line by its KEY via the id property, not by index. Shopify's
  Cart API docs recommend this because a cart can hold several lines for the
  same variant, and the index shifts whenever a line is added or removed.
==============================================================================*/
ShopifyAPI.changeLineJSON = function(payload, callback, errorCallback) {
    var $body = $(document.body);
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        dataType: 'json',
        beforeSend: function() {
            $body.trigger('beforeChangeItem.ajaxCart', [payload.id, payload.quantity]);
        },
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);updateFreeShippingThersold();} else {
                ShopifyAPI.onCartUpdate(cart);
            }
            $body.trigger('afterChangeItem.ajaxCart', [payload.id, payload.quantity, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                errorCallback(XMLHttpRequest, textStatus);
            } else {
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
            $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
            $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        }
    });
};

/*============================================================================
  Subscription helpers

  Waterless Shampoo uses native Shopify selling plans, so /cart.js returns a
  selling_plan_allocation object on subscription lines. Everything below reads
  from that payload only. Nothing here is specific to one product, and nothing
  calls an app API.

  Plan names on this store read like:
    "12 week subscription with 20% discount"
  and the plan options array carries a "12-week" token as a fallback.
==============================================================================*/
var cdSubscription = (function() {

    // "12 week subscription with 20% discount" -> interval + discount phrasing
    function planSummary(sellingPlan) {
        var name = (sellingPlan && sellingPlan.name) || '';
        var weeks = null;
        var pct = null;

        var weekMatch = name.match(/(\d+)\s*-?\s*week/i);
        if (weekMatch) {
            weeks = parseInt(weekMatch[1], 10);
        }

        // Fall back to the plan option tokens if the name is ever reworded
        if (weeks === null && sellingPlan && sellingPlan.options) {
            for (var i = 0; i < sellingPlan.options.length; i++) {
                var optMatch = String(sellingPlan.options[i]).match(/(\d+)\s*-?\s*week/i);
                if (optMatch) {
                    weeks = parseInt(optMatch[1], 10);
                    break;
                }
            }
        }

        var pctMatch = name.match(/(\d+(?:\.\d+)?)\s*%/);
        if (pctMatch) {
            pct = pctMatch[1];
        }

        return {
            interval: weeks ? ('Delivered every ' + weeks + ' weeks') : (name || 'Recurring delivery'),
            discount: pct ? (pct + '% off every order') : '',
            percent: pct ? (pct + '%') : '',
            pctNum: pct ? parseFloat(pct) : null,
            weeks: weeks
        };
    }

    /* -------------------------------------------------------------------------
       RRP for a subscription line.

       This exists because Shopify's original_line_price is NOT the RRP on a
       selling plan line - the plan adjustment is already folded into it. For
       3 tubes it comes back as 3 x $31.92 = $95.76, not 3 x $39.90 = $119.70.

       Reading that field directly is what made the drawer disagree with the
       PDP: the buy box struck out $119.70 and the drawer struck out $95.76 for
       the same line, so the same subscription looked like two different deals
       depending on which screen you were on.

       Two ways to recover the real RRP, in order of preference:

         1. selling_plan_allocation.compare_at_price, when Shopify populates it.
            Exact, no arithmetic.

         2. Reverse the plan percentage out of the unit price. 3192 / 0.8 =
            3990. Exact whenever the original divides cleanly, which it does at
            these prices; it can land a cent out on awkward numbers, which is
            why it is the fallback rather than the primary.

       Returns 0 when neither route works, and the caller then keeps Shopify's
       own original_line_price rather than inventing a comparison.
       ------------------------------------------------------------------------- */
    function unitRrp(allocation, plan, unitOriginal) {
        if (allocation && typeof allocation.compare_at_price === 'number' && allocation.compare_at_price > unitOriginal) {
            return allocation.compare_at_price;
        }
        if (plan && plan.pctNum && plan.pctNum > 0 && plan.pctNum < 100) {
            return Math.round(unitOriginal / (1 - (plan.pctNum / 100)));
        }
        return 0;
    }

    return {
        planSummary: planSummary,
        unitRrp: unitRrp
    };
}());

/*============================================================================
  Quantity <-> selling plan binding

  The bundle size and the delivery interval are two views of the same choice:
  1 tube every 6 weeks, 2 every 12, 3 every 18. The PDP buy box pairs them by
  INDEX - the nth bundle takes the nth shortest plan - and this module keeps
  that pairing true once the line is in the cart.

  Two jobs:

    1. changeQty() - when the shopper nudges quantity on a subscription line,
       send the new quantity AND the matching selling plan together, so they
       can never drift apart.

    2. reconcile() - repair lines that drifted anyway. Adding the same
       subscription twice from the PDP merges into one line at quantity 2 on
       the 1-tube plan, which never passes through the stepper and so was
       previously invisible: 2 tubes arriving every 6 weeks instead of every
       12. reconcile() runs after every cart render and corrects the plan.

  Plans are read from /products/{handle}.js rather than hardcoded, so this
  works for any future subscription product without edits. Results are cached
  per handle for the life of the page.
==============================================================================*/
var cdPlanBinding = (function($) {

    var cache = {};
    var inFlight = {};
    var attempted = {};

    /* Plans for a product handle, sorted by interval ascending. */
    function plansFor(handle) {
        if (!handle) { return $.Deferred().reject().promise(); }
        if (cache[handle]) { return $.Deferred().resolve(cache[handle]).promise(); }
        if (inFlight[handle]) { return inFlight[handle]; }

        inFlight[handle] = $.getJSON('/products/' + handle + '.js').then(function(product) {
            var list = [];
            var groups = (product && product.selling_plan_groups) || [];

            for (var g = 0; g < groups.length; g++) {
                var plans = groups[g].selling_plans || [];
                for (var p = 0; p < plans.length; p++) {
                    var weeks = cdSubscription.planSummary(plans[p]).weeks;
                    if (weeks) {
                        list.push({ weeks: weeks, id: plans[p].id });
                    }
                }
            }

            list.sort(function(a, b) { return a.weeks - b.weeks; });
            cache[handle] = list;
            delete inFlight[handle];
            return list;
        });

        return inFlight[handle];
    }

    /* Bundle size N takes the Nth shortest plan, matching the buy box.

       Quantities beyond the number of plans fall back to the LONGEST plan
       rather than clamping the quantity. Silently removing a tube someone
       deliberately added is worse than an imperfect cycle, and the shopper
       can always see the interval on the line. */
    function planForQty(list, qty) {
        if (!list || !list.length) { return null; }
        var index = Math.min(Math.max(qty, 1), list.length) - 1;
        return list[index];
    }

    function changeQty(handle, key, qty, done) {
        if (qty <= 0) {
            ShopifyAPI.changeLineJSON({ id: key, quantity: 0 }, done);
            return;
        }

        plansFor(handle).then(function(list) {
            var plan = planForQty(list, qty);
            var payload = { id: key, quantity: qty };
            if (plan) { payload.selling_plan = plan.id; }
            ShopifyAPI.changeLineJSON(payload, done);
        }, function() {
            /* Plan lookup failed. Change the quantity anyway rather than
               dead-ending the shopper; reconcile() will fix the plan on the
               next render if the lookup recovers. */
            ShopifyAPI.changeLineJSON({ id: key, quantity: qty }, done);
        });
    }

    /* Repair drifted lines. Safe to call on every render: it only fires when
       the plan actually disagrees with the quantity, and the attempted map
       stops it retrying the same key+quantity forever if a fix fails. */
    function reconcile(cart, done) {
        if (!cart || !cart.items) { return; }

        $.each(cart.items, function(index, item) {
            var alloc = item.selling_plan_allocation;
            if (!alloc || !alloc.selling_plan) { return; }

            var currentWeeks = cdSubscription.planSummary(alloc.selling_plan).weeks;
            if (!currentWeeks) { return; }

            var stamp = item.key + ':' + item.quantity;
            if (attempted[stamp]) { return; }

            plansFor(item.handle).then(function(list) {
                var want = planForQty(list, item.quantity);
                if (!want || want.weeks === currentWeeks) { return; }

                attempted[stamp] = true;
                ShopifyAPI.changeLineJSON({
                    id: item.key,
                    quantity: item.quantity,
                    selling_plan: want.id
                }, done);
            });
        });
    }

    return {
        plansFor: plansFor,
        planForQty: planForQty,
        changeQty: changeQty,
        reconcile: reconcile
    };

}(jQuery));

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: '#CartCount',
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride($formContainer);
        }
        if (!settings.disableAjaxCart) {
            formOverride($('#upsell_form'));
        }
        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $('.cart-count-bubble').hide();
            } else {
                $('.cart-count-bubble').show();
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function(form) {
        form.on('submit', function(evt) {
            evt.preventDefault();

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');
            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function(product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    itemErrorCallback = function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $cartContainer.before('<div class="errors qty-error">' + data.description + '</div>')
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $('#CartContainer').addClass('empty_CartDrawer');
            $('#is-a-gift').hide();
            $cartContainer
                .append('<p>Your cart is empty</p>');
            cartCallback(cart);
            return;
        } else {
            $('#CartContainer').removeClass('empty_CartDrawer');
            $('#is-a-gift').show();
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        var cartHasSubscription = false;

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {

            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_180X$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            /* ----------------------------------------------------------------
               Subscription state for this line.

               allocation is present only when the line was added with a
               selling plan, so its presence is the subscription test.

               Quantity is NOT locked on these lines. The interval is bound to
               the bundle size (1 tube / 6wk, 2 / 12wk, 3 / 18wk), and rather
               than freezing the stepper to protect that binding, the stepper
               changes the quantity and the selling plan together via
               cdPlanBinding. See the comment on that module.
               ---------------------------------------------------------------- */
            var allocation = cartItem.selling_plan_allocation || null;
            var isSubscription = !!(allocation && allocation.selling_plan);
            var plan = isSubscription ? cdSubscription.planSummary(allocation.selling_plan) : null;

            if (isSubscription) {
                cartHasSubscription = true;
            }

            /* ----------------------------------------------------------------
               LINE totals, not unit prices.

               Showing line totals is what let the old "3 x $25.54 = $76.62"
               row be deleted - the maths is no longer something the shopper
               has to follow.

               THE STRIKE-THROUGH IS RRP x QUANTITY, matching the PDP buy box.

               It cannot just be original_line_price, because Shopify folds the
               selling plan adjustment into that field: 3 tubes comes back as
               3 x $31.92 = $95.76 rather than 3 x $39.90 = $119.70. Using it
               directly meant the drawer struck out a different number from the
               buy box for the very same line.

               cdSubscription.unitRrp recovers the pre-plan unit price. If it
               cannot, it returns 0 and Shopify's own original_line_price is
               kept rather than inventing a comparison.
               ---------------------------------------------------------------- */
            var unitOriginal = typeof cartItem.original_price === 'number' ? cartItem.original_price : cartItem.price;
            var originalLine = typeof cartItem.original_line_price === 'number' ? cartItem.original_line_price : 0;
            var finalLine = typeof cartItem.final_line_price === 'number' ? cartItem.final_line_price : cartItem.line_price;

            var compareLine = originalLine;
            if (isSubscription) {
                var rrp = cdSubscription.unitRrp(allocation, plan, unitOriginal);
                if (rrp) { compareLine = rrp * cartItem.quantity; }
            }

            var lineSaving = Math.max(0, compareLine - finalLine);

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,

                /* 1-based index into Shopify's OWN ordering of cart.items.

                   This is assigned here, before the reverse below, and must
                   stay that way. ShopifyAPI.changeItem() identifies a row by
                   this number, so if it were derived from display order every
                   stepper would edit the wrong line. */
                line: index + 1,

                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                vendor: cartItem.vendor,

                /* ---- redesign fields ---- */
                handle: cartItem.handle,
                isSubscription: isSubscription,
                planInterval: plan ? plan.interval : '',

                /* Still computed, but no longer printed. The percentage stated
                   the PLAN discount only, which sat oddly beside a saving that
                   also includes the bundle discount - the same contradiction
                   the PDP tier chips had. Kept here so restoring the line is a
                   one-element change in the template. */
                planPercent: plan ? plan.percent : '',
                planName: isSubscription ? allocation.selling_plan.name : '',

                lineOriginalMoney: Shopify.formatMoney(compareLine, settings.moneyFormat),
                lineFinalMoney: Shopify.formatMoney(finalLine, settings.moneyFormat),
                lineSavingMoney: Shopify.formatMoney(lineSaving, settings.moneyFormat),
                hasLineSaving: lineSaving > 0
            };
            items.push(item);
        });

        /* NEWEST LINE FIRST.

           Shopify returns cart.items oldest first and appends new adds to the
           end, so without this a product added from "Others also bought" would
           appear at the BOTTOM of the drawer, below the fold, and look like
           nothing happened. Reversing puts it directly above the previously
           added item where the shopper is already looking.

           Display order only. Every item already carries its original Shopify
           line number from the loop above, so the API calls are unaffected. */
        items.reverse();

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),

            /* ---- redesign fields ---- */
            itemCount: cart.item_count,
            itemCountLabel: cart.item_count === 1 ? '1 item' : (cart.item_count + ' items'),
            cartHasSubscription: cartHasSubscription
        }

        $cartContainer.append(template(data));

        cartCallback(cart);

        /* The shipping bar and the contextual upsell both live outside the
           Handlebars output, so re-point them at the cart we just rendered.
           Defined in snippets/cart_drawer.liquid. */
        if (typeof window.cdRenderShipping === 'function') {
            window.cdRenderShipping(cart);
        }

        /* Repair any subscription line whose plan no longer matches its
           quantity. Only fires on an actual mismatch, so on a healthy cart
           this is a no-op. */
        if (!isUpdating) {
            cdPlanBinding.reconcile(cart, adjustCartCallback);
        }
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart
        //Remove Item from cart
        $body.on('click', '.ajaxcart__remove', function() {
            var $el = $(this),
                line = $el.data('line');
            updateQuantity(line, 0);
        })


        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                $wrap = $el.closest('.ajaxcart__qty'),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            /* Subscription lines go through cdPlanBinding so the selling plan
               moves with the quantity in one request. */
            if (String($wrap.attr('data-sub')) === 'true') {
                isUpdating = true;
                $wrap.closest('.ajaxcart__row').addClass('is-loading');
                if (qty === 0) {
                    $wrap.closest('.ajaxcart__product').addClass('is-removed');
                }
                cdPlanBinding.changeQty($wrap.attr('data-handle'), $wrap.attr('data-key'), qty, adjustCartCallback);
                return;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                $wrap = $el.closest('.ajaxcart__qty'),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            if (String($wrap.attr('data-sub')) === 'true') {
                isUpdating = true;
                cdPlanBinding.changeQty($wrap.attr('data-handle'), $wrap.attr('data-key'), qty, adjustCartCallback);
                return;
            }

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);

            $el.addClass('clicked');
            setTimeout(function() {
                $el.select();
                $el.removeClass('clicked');
            }, 1000);

        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
